import { useQuery } from '@tanstack/react-query'
import { API_BASE } from '../data/constants.js'

/**
 * useHomepageRanking — read the homepage's Search Console stats via
 * the worker's /gsc/homepage-ranking endpoint.
 *
 * The worker caches for 1h in KV, so the client can be generous with
 * its own cache. Returns:
 *   { position, impressions, clicks, ctr, startDate, endDate, asOf, hasData }
 */
export function useHomepageRanking() {
  return useQuery({
    queryKey: ['gsc', 'homepage-ranking'],
    queryFn: async () => {
      const res = await fetch(API_BASE + '/gsc/homepage-ranking')
      if (res.status === 503) {
        // Worker isn't configured — return null so the component can
        // render a "not configured" state instead of erroring.
        return null
      }
      if (!res.ok) {
        const msg = await res.text().catch(() => '')
        throw new Error(`HTTP ${res.status} ${msg}`)
      }
      return res.json()
    },
    staleTime: 30 * 60 * 1000, // 30 min
    refetchOnWindowFocus: false,
    retry: 1,
  })
}
